export default {
    optOutShareThoughtsDatapoint: { datapoint: { name: 'OptOutShareThoughts' } },
    optOutDontShareThoughtsDatapoint: { datapoint: { name: 'OptOutNotNow' } },
    optOutCancelDatapoint: { datapoint: { name: 'OptOutCancel' } },
};
